import { ActionReducer, MetaReducer } from '@ngrx/store';
import { authLogout } from 'auth-app-lib';

export function clearStateMetaReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    if (action.type === authLogout.type) {
      state = {};
      localStorage.clear();
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [clearStateMetaReducer];

